import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { CHECKLISTS_ACTION_TYPE } from 'store/system/actions';

// The hidden-inclusive checklist list backing the company-settings "Completeness Checklist"
// picker (DEV-4603). Held separately from `system.checklists` (visible-only) so including hidden
// completeness checklists here never leaks them into the general checklists list or the
// checklists-management page.
const initialState = [];

const completenessChecklistOptionsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case CHECKLISTS_ACTION_TYPE.GET_COMPLETENESS_CHECKLIST_OPTIONS:
        return payload || initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default completenessChecklistOptionsReducer;
